module.exports = __webpack_public_path__ + "img/HPO-figure-for-monarchui.4187299d.png";